//
// Column
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//
// TO CENTER CHILDREN VERTICALLY, WHILE HANDLING
// OVERFLOW Y SCROLLING PROPERLY,
// apply the classname 'my-auto' to them.
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const Column = forwardRef((props, ref) => {
  const {
    className,
    style: propStyle,
    gap = 2,
    absolute,
    start,
    end,
    between,
    around,
    evenly,
    baseline,
    crossStart,
    crossEnd,
    crossStretch,
    framed,
    framedRed,
    framedButton,
    onClick,
    id,
    onKeyPress,
    children = null,
  } = props;

  // Copy, never write into the caller's object: React freezes a style object
  // once it has been committed, and it is never ours to change anyway
  const style = (gap)
    ? { ...propStyle, gap: `${gap / 4}rem` }
    : propStyle;

  const finalClassName = classNames(
    'flex flex-col',
    {
      // Vertical / main axis alignment:
      'justify-start': start,
      'justify-end': end,
      'justify-between': between,
      'justify-around': around,
      'justify-evenly': evenly,
      // Horizontal / cross axis alignment:
      'items-center': !(baseline || crossStart || crossStretch || crossEnd),
      'items-baseline': baseline,
      'items-start': crossStart,
      'items-end': crossEnd,
      'items-stretch': crossStretch,
      'border rounded-md': framed,
      'border-pxOutlineStrong': framed && (!framedRed) && (!framedButton),
      'border-pxUiAlert': framed && framedRed,
      'border-pxPrimary': framed && framedButton,
      'pointer-events-none': (onClick === false),
      'relative': !absolute,
      absolute,
    },
    className,
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={finalClassName}
        style={style}
        onClick={onClick}
        onKeyPress={onKeyPress}
        id={id}
        ref={ref}
      >
        {children}
      </button>
    );
  }

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={finalClassName}
      style={style}
      onKeyPress={onKeyPress}
      id={id}
      ref={ref}
    >
      {children}
    </div>
  );
});
Column.displayName = 'Column';

Column.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  gap: PropTypes.number,
  absolute: PropTypes.bool,
  framed: PropTypes.bool,
  framedRed: PropTypes.bool,
  framedButton: PropTypes.bool,
  // Alignment along main axis:
  start: PropTypes.bool,
  end: PropTypes.bool,
  between: PropTypes.bool,
  around: PropTypes.bool,
  evenly: PropTypes.bool,
  // Alignment across main axis:
  baseline: PropTypes.bool,
  crossStart: PropTypes.bool,
  crossEnd: PropTypes.bool,
  crossStretch: PropTypes.bool,
  children: PropTypes.node,
  // Optional, define both together:
  id: PropTypes.string,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
};

export default Column;
